export const getPathname = (state) => state.router.location.pathname;
